import { render, staticRenderFns } from "./JournalEdit.vue?vue&type=template&id=53ea1880"
import script from "./JournalEdit.vue?vue&type=script&lang=js"
export * from "./JournalEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports